/* no babel so we have to use old js syntax */
window.Popper = require('popper.js');
require('bootstrap');

import "@fontsource/raleway/latin.css";
import "@fontsource/playfair-display/latin.css";

//window.blueimp = require('blueimp-gallery');
window.slick = require('slick-carousel');

;$(function() {

  /*
    $('.slick').slick({
        dots: true,
        infinite: true,
        speed: 300,
        slidesToShow: 1,
    });
    */

    $('.logo-wrap').slick({
        slidesToShow: 5,
        slidesToScroll: 1,
        arrows: false,
        autoplay: true,
        autoplaySpeed: 3000,
        infinite: true,
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    });

    /*
    $('#mainnav')
        .on('show.bs.collapse', function() {

            var nav_margin = $('.navmargin'); //document.getElementById('navmargin');

            nav_margin.addClass('mobile-nav-toggle');
        })
        .on('hide.bs.collapse', function() {
            var nav_margin = $('.navmargin'); //document.getElementById('navmargin');

            nav_margin.removeClass('mobile-nav-toggle');
        });
    */

  /* ajax-form-submission
  var form = $('#contact');
  if(typeof form != 'undefined') {
    $(form).on('submit', function(e) {
      e.preventDefault();
      $('#form-response').html('');
      $(".loader").css('opacity', '1');
      $(".loader").css('opacity', '1');
      $(form).find(':submit').attr('disabled', 'disabled');

      // submit the form via Ajax
      $.ajax({
        url: form.attr('action'),
        type: form.attr('method'),
        data: form.serialize(),
        success: function(result) {
          if ($(result).text().indexOf("Dank") != -1)
          {
            $('#form-response').html(result);
            $(".loader").css('opacity', '0');
            $(form).fadeOut().remove();
          } else {
            $('#form-response').html(result);
            $(form).find(':submit').removeAttr('disabled');
            $(".loader").css('opacity', '0');
          }
        }
      });
    });
  }
  */

});



//////////////////
// WEBPACK FOOTER
// ./js/theme.js
// module id = 3
// module chunks = 0